import keymirror from 'keymirror';
import { AsyncRequest } from 'angieslist-app-platform';

export default keymirror({
  ...AsyncRequest.createActionKeys('ADVERTISE_REQUEST'),
  ...AsyncRequest.createActionKeys('ADVERTISE_CATEGORY_REQUEST'),
  ...AsyncRequest.createActionKeys('ADVERTISE_CONTACT_COUNT'),
});



// WEBPACK FOOTER //
// ./src/app/common/advertise/advertiseActionKeys.js